import React from "react";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import useSociety from "../../../../hooks/useSociety";
import useStripeCheckAccount from "../../../../hooks/useStripeCheckAccount";
import {Button} from "@mui/material";

const VerifyIdentity = () => {

    const {society} = useSociety();

    const {
        isConnectedAccountReady,
        hasConnectedAccount,
        hasDetailsSubmitted,
        isLoadingConnectedAccountState,
    } = useStripeCheckAccount(society.secured || false);

    const navigate = useNavigate();

    return (
        <>
            {!isLoadingConnectedAccountState && (!hasConnectedAccount || !hasDetailsSubmitted) && (
                <>
                    <Typography
                        textAlign={"left"}
                        variant={"secondVariant"}
                        sx={{mt: 2}}
                    >
                        Avant de rendre visibles vos articles à vos futurs clients, nous devons vérifier votre identité.
                        Cela se fait en
                        quelques clics via notre partenaire Stripe. Cliquez sur le bouton ci-dessous pour commencer.
                    </Typography>

                    <Button
                        variant={"firstVariant"}
                        sx={{mt: 2, mb: 2}}
                        onClick={() => navigate('/stripe')}
                    >
                        Vérifier mon identité.
                    </Button>
                </>
            )}

            {hasConnectedAccount && hasDetailsSubmitted && !isConnectedAccountReady && (
                <>
                    <Typography
                        textAlign={"left"}
                        variant={"secondVariant"}
                    >
                        Votre compte n'est pas complet. Vos clients ne verront pas encore vos articles pour le
                        moment mais vous pouvez déjà les créer. Veuillez vérifier que vous avez bien rempli toutes
                        les informations nécessaires.
                    </Typography>
                    <Button
                        variant={"firstVariant"}
                        sx={{mt: 2, mb: 2}}
                    >
                        Compléter mon compte Stripe
                    </Button>
                </>
            )}
        </>
    );
}

export default VerifyIdentity
